export default "__VITE_ASSET__CqWR5OKl__"